import { MonitoringGateway } from './monitoring-gateway.interface';

const baseUrl = 'gk/pings';
export class HttpMonitoringGateway implements MonitoringGateway {

  ping() {
    return { url: `${baseUrl}/ping`, method: 'POST' };
  }

  getAllPingByRoleAndUsername(args: { role: string; searchValue: string; groupName: string }) {
    return {
      url: `${baseUrl}/${args.role}`,
      method: 'GET',
      params: {
        searchValue: args.searchValue,
        groupName: args.groupName
      },
    };
  }
}
